// @flow
export { default } from './Input';
export type { Props } from './Input';



// WEBPACK FOOTER //
// ../react-lib/src/components/formFields/Input/index.js